import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export const inputStyle = {
  fontSize: 16,
  fontWeight: 500,
};

type FieldWrapperProps = { children?: ReactNode };

export const FieldWrapper = styled.div<FieldWrapperProps>`
  margin-right: 5px;
`;

type TitleWrapperProps = { children?: ReactNode };

export const TitleWrapper = styled.div<TitleWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

type WrapperProps = { children?: ReactNode };

export const Wrapper = styled.div<WrapperProps>`
  padding: 10px 25px 20px 40px;
  margin-bottom: 15px;
`;

type ItemProps = { children?: ReactNode; bold?: boolean; marginLeft?: number; padding?: number };

export const Item = styled.div<ItemProps>`
  ${({ bold }) =>
    bold &&
    css`
      font-weight: 500;
    `}

  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: ${marginLeft}px;
    `}

    ${({ padding }) =>
    padding &&
    css`
      padding: ${padding}px;
    `}
`;

type FieldsProps = { children?: ReactNode };

export const Fields = styled.div<FieldsProps>`
  display: flex;
  align-items: center;
`;

type ErrorWrapperProps = { children?: ReactNode };

export const ErrorWrapper = styled.div<ErrorWrapperProps>`
  padding-left: 40px;
  padding-right: 25px;
  margin-bottom: 10px;
`;
